import { render, staticRenderFns } from "./UploadTemp.vue?vue&type=template&id=2c409ed5&scoped=true"
import script from "./UploadTemp.vue?vue&type=script&lang=js"
export * from "./UploadTemp.vue?vue&type=script&lang=js"
import style0 from "./UploadTemp.vue?vue&type=style&index=0&id=2c409ed5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c409ed5",
  null
  
)

export default component.exports